module.exports = __webpack_public_path__ + "media/s2Part2Model1.b4a800af.mp4";